import { FormInstance } from "antd";
import { useCallback, useState } from "react";
import ReportService from "../../../../../../../../../../services/reportGeneration";
import { useDownloadReport } from "../../../../../../../../../../lib/hooks/useDownloadReport";
import { useOpenProgressModal } from "../../../../../../../../../../lib/hooks/useOpenProgressModal";
import { useAppDispatch } from "../../../../../../../../../../store";
import { updateMailingKey } from "../../../../../../../../../../acions/actionsCreators/mailingKeyActions";
import { setErrorMessage } from "../../../../../../../../../../acions/actionsCreators/messageActions";
import { SUCCESS_PDF_DOWNLOAD } from "../../../../../../../../../../lib/constants";

export const usePrint = (
  contractId: string,
  form: FormInstance,
  close: () => void,
) => {
  const NO_PAYERS_ERROR =
    "There are no Payers for whom to generate 1098 Report";

  const NO_SELECTED_PAYERS = "Please, choose a Payer to generate the Report";

  const dispatch = useAppDispatch();

  const [disabled, setDisabled] = useState<boolean>(false);

  const { download } = useDownloadReport(setDisabled);

  const { openModal } = useOpenProgressModal(
    "Generating 1098 Report",
    "Generating 1098 Report failed",
    (id?: string) => {
      download(ReportService, id);

      dispatch(updateMailingKey());
    },
    {
      customMsg: SUCCESS_PDF_DOWNLOAD,
    },
  );

  const onSave = useCallback(async () => {
    try {
      const values = await form.validateFields();

      if (!values.hasOptions) {
        dispatch(setErrorMessage(NO_PAYERS_ERROR, true));
        close();
      } else if (!values.payerIds || values.payerIds.length === 0) {
        dispatch(setErrorMessage(NO_SELECTED_PAYERS, true));
      } else {
        setDisabled(true);

        const id: string = await ReportService.generateReportByName(
          "Report1098/print",
          {
            ...values,
            contractId,
          },
        );

        openModal(id);

        close();
      }
    } catch {
      setDisabled(false);
    }
  }, [form, dispatch, close, contractId, openModal]);

  return { onSave, disabled };
};
